'use client';

import { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'About', href: '#about' },
    { label: 'Batches', href: '#batches' },
    { label: 'Instructors', href: '#instructors' },
    { label: 'Testimonials', href: '#testimonials' },
  ];

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'nav-scrolled py-2' : 'py-4 bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 flex items-center justify-between">
        {/* Logo */}
        <AppLogo
          size={64}
          text="RavisGoldenGarba"
          iconName="SparklesIcon"
          className="cursor-pointer"
        />

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              className="text-[13px] font-semibold text-foreground/70 hover:text-primary transition-colors tracking-wide uppercase"
            >
              {link?.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden md:block">
          <a href="#register" className="btn-primary text-sm px-6 py-3 rounded-xl">
            Register Now
          </a>
        </div>

        {/* Mobile menu toggle */}
        <button
          className="md:hidden p-2 text-foreground"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className="block w-6 h-0.5 bg-foreground mb-1.5 transition-all" />
          <span className="block w-6 h-0.5 bg-foreground mb-1.5 transition-all" />
          <span className="block w-4 h-0.5 bg-foreground transition-all" />
        </button>
      </div>
      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-bg border-t border-primary/10 px-5 py-6 space-y-4">
          {navLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              className="block text-sm font-semibold text-foreground/70 hover:text-primary transition-colors uppercase tracking-wide"
              onClick={() => setMenuOpen(false)}
            >
              {link?.label}
            </a>
          ))}
          <a
            href="#register"
            className="btn-primary block text-center text-sm mt-4"
            onClick={() => setMenuOpen(false)}
          >
            Register Now
          </a>
        </div>
      )}
    </nav>
  );
}